import { render, staticRenderFns } from "./AcceptHamper.vue?vue&type=template&id=0a04ed52"
import script from "./AcceptHamper.vue?vue&type=script&lang=js"
export * from "./AcceptHamper.vue?vue&type=script&lang=js"
import style0 from "./AcceptHamper.vue?vue&type=style&index=0&id=0a04ed52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports